/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from '../../../utils/object';
import { dateMMMMDDYYYY } from '../../../utils/dateString';

const OrderNumber = ({ orderDetailById }) => {
    const firstOrderDetailById = orderDetailById[0];
    let orderDate = '';
    let orderNumber = '';
    try {
        ({ orderNumber, orderDate } = firstOrderDetailById);
        // eslint-disable-next-line no-empty
    } catch (ex) {}
    const orderDateString = dateMMMMDDYYYY(orderDate);
    if (isEmpty(orderDetailById)) return null;

    return (
        <>
            <div className="order-info gray-bg">
                <span className="uppercase gray-color bold">Order #: </span>
                <span className="bold">{orderNumber}</span>
            </div>
            <div className="order-info">
                <span className="uppercase gray-color bold">Order Date: </span>
                <span className="bold">{orderDateString}</span>
            </div>
            <div className="order-info display-none">
                <span className="uppercase gray-color bold">
                    Replacement for:{' '}
                </span>
                <span className="bold">{orderNumber}</span>
            </div>
        </>
    );
};

OrderNumber.defaultProps = {
    orderDetailById: [],
};

OrderNumber.propTypes = {
    orderDetailById: PropTypes.array,
};

export default OrderNumber;
